import { render } from "./TipoView.vue?vue&type=template&id=71213cdc&scoped=true"
import script from "./TipoView.vue?vue&type=script&lang=js"
export * from "./TipoView.vue?vue&type=script&lang=js"

import "./TipoView.vue?vue&type=style&index=0&id=71213cdc&lang=scss&scoped=true"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/plantoes-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71213cdc"]])

export default __exports__